import { useNormalizeReferences } from 'hooks/useNormalizeReferences';
import { WorkTeamsForm } from 'pages/Finance/WorkTeams/components/WorkTeamsForm';
import { WorkTeamsFormSkeleton } from 'pages/Finance/WorkTeams/components/WorkTeamsFormSkeleton';

export const WorkTeamsEditForm: React.FC = () => {
  const { ready } = useNormalizeReferences({
    referenceFields: ['manager', 'members', 'countries'],
  });

  if (!ready) {
    return <WorkTeamsFormSkeleton />;
  }

  return <WorkTeamsForm />;
};
